module.exports = "img/photo2.cd8ac9.jpg";